<template>
  <div :class="question.StyleClass">
    <HomeBaseLabel
      :question="question"
      v-if="question.InterfaceKey !== 'AutoRenewalConsent'"
    />
    <div class="d-flex align-center margin-radio-card-heading">
      <h3 class="font-20">{{ question.Text }}&nbsp;</h3>
      <a
        href="#"
        class="d-inline-flex d-lg-none blueberrypopover--text font-weight-bold"
        @click.prevent="$emit('showDirectDebitRenewalInfo')"
      >
        <span v-if="question.UseIconForHelpDialog"
          ><v-icon color="accent" class="tooltip">mdi-help-circle</v-icon></span
        >
        <span v-else>Find out more</span>
      </a>
    </div>
    <v-radio-group
      row
      hide-details="auto"
      class="radioButtonCard mt-0"
      :data-uiid="question.DataUiid"
      v-model="question.Value"
      :rules="getRules"
      :class="isSelfServe ? 'font-14' : ''"
    >
      <v-row :class="isSelfServe ? 'flex-no-wrap gap-8px' : ''">
        <v-col
          cols="6"
          v-for="(option, index) in question.Options"
          :key="index"
          :class="
            option.Value ? 'radioButtonCard__left' : 'radioButtonCard__right'
          "
        >
          <v-card
            v-if="option.Value"
            :ripple="false"
            class="elevation-0 px-3 px-lg-6 py-5"
            :class="{
              'radioButtonCard--active': question.Value === option.Value,
              'd2c-payment-stay-cover': isSelfServe,
            }"
            :data-uiid="option.DataUiid"
          >
            <div class="d-flex flex-column">
              <div>
                <h3
                  class="font-20 text-center mb-6 d-none d-lg-block"
                  :class="{ 'mb-31px': isSelfServe }"
                >
                  {{ option.Text }}
                </h3>
                <h3 class="font-20 text-center mb-6 d-block d-lg-none">
                  Stay<br />covered
                </h3>
                <ul class="mb-3 d-none d-lg-block">
                  <li class="d-flex">
                    <span class="mr-3"
                      ><v-icon>mdi-checkbox-marked-circle</v-icon></span
                    >
                    <div>
                      <p class="font-weight-bold ma-0 mb-1">
                        Continuous cover for peace of mind
                      </p>
                      <p class="font-14">
                        Paymentshield will renew your policy each year so that
                        you are not left without insurance.
                      </p>
                    </div>
                  </li>
                  <li class="d-flex">
                    <span class="mr-3"
                      ><v-icon>mdi-checkbox-marked-circle</v-icon></span
                    >
                    <div>
                      <p class="font-weight-bold ma-0 mb-1">
                        Our cheapest price available
                      </p>
                      <p class="font-14">
                        By searching their panel of insurers Paymentshield will
                        always look to provide the cheapest price they can offer
                        you each year.
                      </p>
                    </div>
                  </li>
                  <li class="d-flex">
                    <span class="mr-3"
                      ><v-icon>mdi-checkbox-marked-circle</v-icon></span
                    >
                    <div>
                      <p class="font-weight-bold ma-0 mb-1">
                        You're still in control
                      </p>
                      <p class="font-14">
                        You can cancel your policy or opt out of auto renewal
                        free of charge at any time by calling or using the chat
                        service.
                      </p>
                    </div>
                  </li>
                  <li class="d-flex">
                    <span class="mr-3"
                      ><v-icon>mdi-checkbox-marked-circle</v-icon></span
                    >
                    <div>
                      <p class="font-weight-bold ma-0 mb-1">Stay informed</p>
                      <p class="font-14">
                        Paymentshield will contact you up to 30 days before your
                        policy renews to confirm the cover, price &amp; insurer
                        for your next insurance term.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
              <v-btn
                :ripple="false"
                depressed
                rounded
                x-large
                outlined
                class="font-20 font-weight-bold text-capitalize mt-auto"
                @click="getValue(option)"
              >
                <span
                  v-if="question.Value === option.Value"
                  class="d-inline-flex align-center"
                >
                  <v-icon color="white" class="d-none d-lg-block mr-2"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  Selected
                </span>
                <span v-else>Select</span>
              </v-btn>
            </div>
          </v-card>
          <v-card
            v-else
            :ripple="false"
            class="elevation-0 px-3 px-lg-6 py-5"
            :class="{
              'radioButtonCard--active': question.Value === option.Value,
              'd2c-payment-stay-cover': isSelfServe,
            }"
            :data-uiid="option.DataUiid"
          >
            <div class="d-flex flex-column">
              <div>
                <h3 class="font-20 text-center mb-6 d-none d-lg-block">
                  {{ option.Text }}
                </h3>
                <h3 class="font-20 text-center mb-6 d-block d-lg-none">
                  Don't auto<br />renew
                </h3>
                <ul class="mb-3 d-none d-lg-block">
                  <li class="d-flex">
                    <span class="mr-3"><v-icon>mdi-alert-circle</v-icon></span>
                    <div>
                      <p class="font-weight-bold ma-0 mb-1">
                        Not automatically insured
                      </p>
                      <p class="font-14">
                        By searching their panel of insurers, Paymentshield will
                        still offer you their most competitive price at the end
                        of the policy.
                      </p>
                    </div>
                  </li>
                  <li class="d-flex">
                    <span class="mr-3"><v-icon>mdi-alert-circle</v-icon></span>
                    <div>
                      <p class="font-weight-bold ma-0 mb-1">
                        You'll need to arrange cover
                      </p>
                      <p class="font-14">
                        When choosing to opt out of our automatic renewal
                        service, please make sure you have adequate insurance
                        cover in place once your policy comes to an end as you
                        will no longer have insurance with Paymentshield.
                      </p>
                    </div>
                  </li>
                  <li class="d-flex">
                    <span class="mr-3"><v-icon>mdi-alert-circle</v-icon></span>
                    <div>
                      <p class="font-weight-bold ma-0 mb-1">Stay informed</p>
                      <p class="font-14">
                        Paymentshield will contact you up to 30 days before your
                        policy renews to confirm the cover, price &amp; insurer
                        for your next insurance term.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
              <v-btn
                :ripple="false"
                depressed
                rounded
                x-large
                outlined
                class="font-20 font-weight-bold text-capitalize mt-auto"
                @click="getValue(option)"
              >
                <span
                  v-if="question.Value === option.Value"
                  class="d-inline-flex align-center"
                >
                  <v-icon color="white" class="d-none d-lg-block mr-2"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  Selected
                </span>
                <span v-else>Select</span>
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-radio-group>
  </div>
</template>

<script>
import QuestionValidation from "@/Mixins/Validation/QuestionValidation";
import HomeBaseLabel from "@/components/HomeComponents/HomeBaseComponents/HomeBaseLabel";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapGetters } from "vuex";

export default {
  name: "RadioButtonCard",
  components: {
    HomeBaseLabel,
  },
  mixins: [QuestionValidation],
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["isSelfServe"]),
  },
  methods: {
    getValue(option) {
      this.question.Value = option.Value;
    },
  },
  mounted() {
    // Restore true/false value from string
    if (typeof this.question.Value === "string")
      this.question.Value = this.question.Value === "true";
  },
};
</script>

<style lang="scss" scoped>
.margin-radio-card-heading {
  margin: 40px 0 11px 0;
}

@media screen and (max-width: ($grid-breakpoints-md - 1)) {
  .v-card {
    height: 172px;

    > div {
      max-height: 100%;
    }

    .v-btn {
      font-size: 16px !important;
    }
  }
}
</style>
